<template>
	<div>
		<m-operate :style="{'border-width': private ? '0' : '1px 1px 0'}">
			<template v-if="!private">
				<c-button @click="fieldBatchSet('is_enable', 1)">开启全部权限</c-button>
				<c-button @click="fieldBatchSet('is_enable', 2)">关闭全部权限</c-button>
			</template>

			<template #right>
				<c-button @click="fieldBatchSet('is_display', 1)">显示全部</c-button>
				<c-button @click="fieldBatchSet('is_display', 2)">隐藏全部</c-button>
			</template>
		</m-operate>
		<c-table ref="field" height="grow" :border="!private" :paging="false">
			<c-table-column
				type="drag"
				@handle="editState = true"
			></c-table-column>

			<c-table-column
				v-if="!private"
				label="字段权限"
				width="80"
			>
				<template #default="{data}">
					<c-switch v-model="data.is_enable" :state-value="[1, 2]" @change="editState = true"></c-switch>
				</template>
			</c-table-column>

			<c-table-column
				label="字段名称"
				width="260"
			>
				<template #default="{data}">
					<span :style="{'color': data.is_display == 2 || data.is_enable == 2 ? '#aaa' : ''}">{{data.field_title}}</span>
				</template>
			</c-table-column>

			<c-table-column
				label="操作"
				width="100"
				align-center
				:title="false"
			>
				<template #default="row">
					<div v-show="private || row.data.is_enable == 1" class="field-button flex-center">
						<a v-if="fixedButton" @click="lockHandle(row)"><i class="tf" :style="{'color': row.data.is_lock == 1 ? 'var(--color-main)' : ''}">{{row.data.is_lock == 1 ? '&#xe9bb;' : '&#xe9ba;'}}</i></a>
						<a @click="displayHandle(row)"><i class="tf" :style="{'color': row.data.is_display == 2 ? '#aaa' : ''}">{{row.data.is_display == 1 ? '&#xe6dc;' : '&#xe61e;'}}</i></a>
					</div>
				</template>
			</c-table-column>
		</c-table>
	</div>
</template>

<script>
	export default {
		props: {
			private: Boolean,
			fixedButton: {
				type: Boolean,
				default: true
			}
		},

		data() {
			return {
				editState: false
			}
		},

		methods: {
			fieldBatchSet(key, val) {
				this.editState = true;
				this.$refs.field.getRow(row => {
					row.update({
						[key]: val
					})
				})
			},

			set(data) {
				this.editState = false;
				this.$refs.field.setData(data.filter(item => item.is_lock == 1).concat(data.filter(item => item.is_lock != 1)));
			},

			get() {
				return this.$refs.field.getData(this.private ? 'all' : row => row.data.is_enable == 1).map(item => {
					return {
						field_id: item.field_id,
						field_title: item.field_title,
						is_display: item.is_display,
						is_lock: item.is_lock,
						width: item.width
					}
				});
			},

			lockHandle(row) {
				this.editState = true;
				if (row.data.is_lock == 1) {
					row.moveTo(this.$refs.field.getData(row => row.data.is_lock == 1).length - 1);
				} else {
					row.moveTo(this.$refs.field.getData(row => row.data.is_lock == 1).length);
				}
				row.data.is_lock = row.data.is_lock == 1 ? 2 : 1;
			},

			displayHandle(row) {
				this.editState = true;
				row.data.is_display = row.data.is_display == 1 ? 2 : 1;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.field-button {
		gap: 5px;

		a {
			padding: 5px;
			font-size: 18px;
			color: #333;

			&:hover {
				color: var(--color-main);
			}
		}	
	}
</style>
